import axios from "axios";
import { pastProjectsUrl } from "../utils";

export const fetchPastProjects = async (professionalId?: string) => {
  return await axios.get(pastProjectsUrl(professionalId));
};
